import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiVercel,
  SiAdobephotoshop,
  SiAdobeillustrator,
  SiBlender,
  SiFigma,
  SiTrello,
  SiUnity,
} from "react-icons/si";

function Toolstack() {

  const textStyle = {
    fontSize: "20px", // Esto hace el texto más pequeño que el estándar
    marginTop: "5px",  // Un poco de espacio entre el ícono y el texto
    textAlign: "center"
  };

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
        <p style={textStyle}>Visual Studio Code</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
        <p style={textStyle}>Postman</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiSlack />
        <p style={textStyle}>Slack</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVercel />
        <p style={textStyle}>Vercel</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAdobephotoshop />
        <p style={textStyle}>Adobe Photoshop</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiAdobeillustrator />
        <p style={textStyle}>Adobe Illustrator</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiBlender />
        <p style={textStyle}>Blender</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFigma />
        <p style={textStyle}>Figma</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiTrello />
        <p style={textStyle}>Trello</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiUnity />
        <p style={textStyle}>Unity</p>
      </Col>
    </Row>
  );
}

export default Toolstack;
